(function (){
    'use strict';

    angular
        .module('services')
        .service('CountriesNewService', CountriesNewService);

    CountriesNewService.$inject = ['$http', 'API_BASE'];

    function CountriesNewService ($http, API_BASE) {
        var service = this;

        service.getCountries        = getCountries;
        service.getCountryById      = getCountryById;
        service.getCountriesAdmin   = getCountriesAdmin;
        service.getRegions          = getRegions;
        service.getCities           = getCities;
        service.getTerritories      = getTerritories;
        service.getCountriesByTerritoryId = getCountriesByTerritoryId;

        function getCountries (cod) {
            return $http.get(API_BASE + '/countries/list',{params:{id:cod}});
        }

        function getCountryById (cod) {
            return $http.get(API_BASE + '/countries/get',{params:{id:cod}});
        }

        function getCountriesAdmin (cod) {
            return $http.get(API_BASE + '/countries/list/admin',{params:{id:cod}});
        }

        function getRegions (country_id) {
            return $http.get(API_BASE + '/countries/'+country_id+'/regions/list');
        }

        function getCities (country_id, region_id) {
            return $http.get(API_BASE + '/countries/'+country_id+'/regions/'+region_id+'/cities/list');
        }

        function getTerritories () {
            return $http.get(API_BASE + '/territories/list');
        }

        function getCountriesByTerritoryId(territory_id) {
            return $http.get(API_BASE + '/countries/territory/'+territory_id);
        }

    }
})();